import { PendingVideoUploadResponse } from '@pixacare/dtos';

// The server returns one flat list of ongoing sessions for a client; both the reducer (to seed the
// sync-center) and the effects (to re-insert the gallery placeholders) need them per sequence.
export const groupSessionsBySequence = (
  sessions: PendingVideoUploadResponse[],
): Record<number, PendingVideoUploadResponse[]> =>
  sessions.reduce<Record<number, PendingVideoUploadResponse[]>>((groups, session) => {
    (groups[session.sequenceId] ??= []).push(session);
    return groups;
  }, {});
